
    import {
      getAllContactTypes,
      createContactType,
      createAllContactTypes,
      updateContactType,
      deleteContactType
    } from "@/services/contactType";

    const state = {
      contactTypes: [],
      processed: false
    };

    const getters = {
      getContactTypes(state) {
        return state.contactTypes;
      },
      contactTypeProcessed(state){
        return state.processed;
      }
    };

    const actions = {
      fetchContactTypes({ commit }, params) {
          commit("SET_PROCESSING");
          return new Promise((resolve, reject) => {
            getAllContactTypes(
              params
            )
              .then(response => {
                commit("SET_CONTACTTYPES", response.data);
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        createContactType({ commit }, contactType) {
          return new Promise((resolve, reject) => {
            createContactType(contactType)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        createAllContactTypes({ commit }, contactTypes) {
          return new Promise((resolve, reject) => {
            createAllContactTypes(contactTypes)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        updateContactType({ commit }, contactType) {
          return new Promise((resolve, reject) => {
            updateContactType(contactType)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        deleteContactType({ commit }, id) {
          return new Promise((resolve, reject) => {
            deleteContactType(id)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        }
      };

    const mutations = {
      SET_CONTACTTYPES(state, data) {
        state.contactTypes = data;
        state.processed = true;
      },
      SET_PROCESSING(state) {
        state.processed = false;
      },
      SET_PROCESSED(state) {
        state.processed = true;
      }
    };

    export default {
      state,
      getters,
      actions,
      mutations
    };
    